import { useReportsContext } from '../contexts/ReportsContext';
import { WeatherReport } from '../utils/api';

interface UseReportsResult {
  reports: WeatherReport[];
  isLoading: boolean;
  error: string | null;
  refreshReports: () => Promise<void>;
  deleteReport: (reportId: string) => Promise<boolean>;
}

export const useReports = (): UseReportsResult => {
  const context = useReportsContext();
  
  return {
    reports: context.reports,
    isLoading: context.isLoading,
    error: context.error,
    refreshReports: context.refreshReports,
    deleteReport: context.deleteReport,
  };
};